<template>
  <div class="shadow-card">
    <div :style="{ display: 'flex', alignItems: 'center' }" class="recommened-container">
      <a-avatar
        @click="() => viewProfile('reviewee')"
        :style="{
          color: ' #ffffff !important',
          backgroundColor: image ? 'transparent' : getAvatarColor(review.reviewee_id),
          fontSize: '20px',
          fontWeight: '900',
        }"
        :src="image"
        :size="70"
        alt="reviewee profile picture"
        class="text-capitalize cp"
      >
        {{ name ? name[0] : "" }}
      </a-avatar>
      <div :style="{ flex: 1, 'margin-left': '16px' }">
        <div class="d-flex flex-direction-row mobile-res" :style="{ 'flex-wrap': 'wrap' }">
          <p class="text-name cp" @click="() => viewProfile('reviewee')">{{ name }}{{ title }}</p>
          <span class="text-reviewed">
            <i
              class="fa fa-thumbs-o-up fa-sm"
              :style="{
                width: '24px',
                paddingLeft: '5px',
              }"
              aria-hidden="true"
            ></i
            >has been recommended</span
          >
        </div>

        <p class="text-day">{{ time }}</p>
      </div>
      <p
        class="text-link"
        :style="{ color: getPrimaryColor() }"
        @click="
          $router.push({
            name: 'IndividualRecommend',
            params: { id: review.reviewee_id },
          })
        "
        v-if="showViewAllBtn"
      >
        View all recommendations
      </p>
    </div>
    <a-divider type="horizontal" style="margin: 16px 0px" />
    <div :style="{ display: 'flex', alignItems: 'center' }">
      <a-avatar
        @click="() => viewProfile('reviewer')"
        :style="{
          color: ' #ffffff !important',
          backgroundColor: review.reviewer[0].url ? 'transparent' : getAvatarColor(review.reviewer_id),
          fontSize: '12px',
          fontWeight: '900',
        }"
        :src="review.reviewer[0].url"
        :size="40"
        class="text-capitalize cp"
        alt="reviewer profile picture"
      >
        {{ review.reviewer[0].display_name ? review.reviewer[0].display_name[0] : "" }}
      </a-avatar>
      <div :style="{ flex: 1 }">
        <p @click="() => viewProfile('reviewer')" class="text-name cp" :style="{ marginBottom: '0px', textTransform: 'capitalize' }">
          <small :style="{ textTransform: 'lowercase' }">by</small>
          {{ review.reviewer[0].display_name }}
        </p>
      </div>
      <div
        class="star-container"
        :style="{
          background: getPrimaryColor(),
        }"
      >
        <font-awesome-icon size="2x" style="transform: scale(0.7); width: 24px; height: 24px; color: white" :icon="['fas', 'thumbs-up']" />
      </div>
    </div>
    <p
      class="text-link-mobile"
      :style="{ color: getPrimaryColor() }"
      @click="
        $router.push({
          name: 'IndividualRecommend',
          params: { id: review.reviewee_id },
        })
      "
      v-if="showViewAllBtn"
    >
      View all recommendations
    </p>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { faFilter, faStar, faFlag, faThumbsDown, faThumbsUp, faAngleDown, faAngleUp } from "@fortawesome/pro-solid-svg-icons"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

const PostRepository = RepositoryFactory.get("posts")
const UserRepository = RepositoryFactory.get("user")
library.add(faFilter, faFlag, faStar, faThumbsDown, faThumbsUp, faAngleDown, faAngleUp)

export default {
  name: "RecommendCard",
  props: {
    reviewData: Object,
    showViewAllBtn: { default: true, type: Boolean },
  },
  data() {
    return {
      review: null,
      image: null,
      name: null,
      title: null,
      reviewType: null,

      rating_value_list: [],
      expand: false,
      time: "",
      description: null,
      seeMore: true,
      reaction: { flag: false, like: false, dislike: false },
      like_id: null,
      dislike_id: null,
      flag_id: null,
    }
  },

  created() {
    this.review = this.reviewData
    this.reaction.flag = this.review.flag_reaction ? true : false
    this.reaction.like = this.review.like_reaction ? true : false
    this.reaction.dislike = this.review.dislike_reaction ? true : false
    this.flag_id = this.review.flag_reaction ? this.review.flag_reaction[0].id : null
    this.like_id = this.review.like_reaction ? this.review.like_reaction[0].id : null
    this.dislike_id = this.review.dislike_reaction ? this.review.dislike_reaction[0].id : null
    this.time = this.formatPostTime(this.review.created_at)
    if (this.review.reviewee_role === "rec") {
      this.name = "3D Aerobics"
      this.title = " "
      this.reviewType = this.review.type
    } else if (this.review.reviewee_role === "doctor") {
      this.image = this.review.reviewee.url
      this.name = this.review.reviewee.first_name + " " + this.review.reviewee.last_name
      this.title = `, ${this.review.reviewee.title}`
      this.reviewType = this.review.type
    } else if (this.review.reviewee_role === "hospital_administrator") {
      this.image = this.review.reviewee.image
      this.name = this.review.reviewee.hospital_name
    } else if (this.review.reviewee_role === "clinic_administrator") {
      this.image = this.review.reviewee.image
      this.name = this.review.reviewee.clinic_name
    } else if (this.review.reviewee_role === "nfp_administrator" || this.review.reviewee_role === "nfp") {
      this.image = this.review.reviewee.image
      this.name = this.review.reviewee.nfp_name
    } else if (this.review.reviewee_role === "hcp") {
      this.image = this.review.reviewee.image
      this.name = this.review.reviewee.full_name
      this.reviewType = this.review.type
    }
    this.description = this.review.description
  },
  methods: {
    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },

    getRating(rating) {
      return parseFloat(rating).toFixed(1)
    },

    viewProfile(type = "reviewee") {
      const user = this.review
      if (type === "reviewee") {
        if (user.reviewee.hasOwnProperty("is_virtual")) {
          this.routeProfile(type)
        } else {
          this.profile(type)
        }
      } else {
        this.profile(type)
      }
    },
    profile(type = "reviewee") {
      const user = this.review
      if (type === "reviewee") {
        if (user.reviewee.hasOwnProperty("ext_ref_id")) {
          user["user_id"] = user.reviewee.ext_ref_id
        } else {
          user["user_id"] = user.reviewee.id
        }
        user["role"] = user.reviewee_role
      } else {
        user["user_id"] = user.reviewer_id
        user["role"] = user.reviewer_role
      }
      if (user.role === "admin") {
        return
      }
      this.loadingScreen = true
      if (user.user_id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(
          user.reviewee.hasOwnProperty("ext_ref_id") && type === "reviewee" ? { ext_ref_id: user.user_id, role: user.role } : { id: user.user_id, role: user.role },
          this.currentCircle.id
        )
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
              case "physician":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.user_id },
                })
                break
              case "clinic_administrator":
                this.$router.push({
                  name: "ViewClinicAbout",
                  params: { id: user.user_id },
                })
                break
              case "hospital_administrator":
                this.$router.push({
                  name: "ViewHos_adminAbout",
                  params: { id: user.user_id },
                })
                break
              case "nfp":
                this.$router.push({
                  name: "ViewNfpAbout",
                  params: { id: user.user_id },
                })
                break
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.user_id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.user_id, role: 'caregiver' },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateAbout",
                  params: { id: user.user_id },
                })
                break
              case "hospital":
                this.$router.push({
                  name: "HospViewAbout",
                  params: { id: user.user_id },
                })
                break
              case "clinic":
                this.$router.push({
                  name: "ClinicViewAbout",
                  params: { id: user.user_id },
                })
              case "nfp_administrator":
                this.$router.push({
                  name: "ViewNfpAdminAbout",
                  params: { id: user.user_id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {
            this.loadingScreen = false
          })
      }
    },
    routeProfile(type = "reviewee") {
      this.loadingScreen = true
      let info = {}
      if (type === "reviewee") {
        info = this.review.reviewee
        if (!info.hasOwnProperty("role")) {
          info["role"] = this.review.reviewee_role
        }
      } else {
        info = this.review.reviewer[0]
        if (!info.hasOwnProperty("role")) {
          info["role"] = this.review.reviewer_role
        }
      }
      if (Number(info.ext_ref_id) === this.authUser.user.ext_ref_id && info.role === this.authUser.user.role) {
        switch (info.role) {
          case "hospital_administrator":
            this.$router.push({ name: "HosAbout" })
            break
          case "hcp":
            this.$router.push({ name: "HcpAbout" })
            break
          case "nfp_administrator":
            this.$router.push({ name: "NFPAbout" })
            break
          case "clinic_administrator":
            this.$router.push({ name: "ClinicAbout" })
            break
          case "doctor":
            this.$router.push({ name: "DocUpdates" })
            break
          case "Business":
            break
          default:
            this.$router.push({ name: "DocUpdates" })
            break
        }
      } else {
        let data = { ...info, role: info.role }

        switch (info.role) {
          case "physician":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({
                  ...info,
                  role: "doctor",
                  id: info.id,
                })
            break
          case "doctor":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({
                  ...info,
                  role: "doctor",
                  id: info.id,
                })
            break
          case "providers":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : data.ext_ref_id
              ? this.viewEntityProfile({ ...info, role: "doctor" })
              : this.viewProfile({
                  ...info,
                  role: "doctor",
                  id: info.id,
                })
            break
          case "other":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "hcp" })
            break
          case "hcp":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "hcp" })
            break
          case "hcp_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hcp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "hcp" })
          case "hospital":
            info.id
              ? data.my_circles_id
                ? this.viewProfile({
                    ...info,
                    role: "hospital_administrator",
                    id: info.my_circles_id,
                    ext_ref_id: null,
                  })
                : this.viewEntityProfile({ ...info, role: "hospital" })
              : data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.id,
                })
            break
          case "hospital_administrator":
            info.id
              ? data.my_circles_id
                ? this.viewProfile({
                    ...info,
                    role: "hospital_administrator",
                    id: info.my_circles_id,
                    ext_ref_id: null,
                  })
                : this.viewEntityProfile({ ...info, role: "hospital" })
              : data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewProfile({
                  ...info,
                  role: "hospital_administrator",
                  id: info.id,
                })
            break
          case "clinic":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "clinic",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile(data)
            break
          case "clinic_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "clinic",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "clinic" })
            break
          case "nfp":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "nfp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile(data)
            break
          case "nfp_administrator":
            data.my_circles_id
              ? this.viewProfile({
                  ...info,
                  role: "nfp",
                  id: info.my_circles_id,
                  ext_ref_id: null,
                })
              : this.viewEntityProfile({ ...info, role: "nfp" })
            break
          case "Business":
            this.loadingScreen = true
            break
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 426px) {
  .recommened-container {
    flex-wrap: wrap !important;
  }
  .text-link {
    display: none;
  }
  .text-link-mobile {
    display: block !important;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    background: #f1f5f9;
    border-radius: 8px;
    padding: 8px;
    text-align: center;
    margin-top: 1rem;
  }
  .mobile-res {
    flex-direction: column !important;
  }
}
.text-link-mobile {
  display: none;
}
.text-name {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 16px;
  margin-bottom: 4px;
  text-transform: capitalize;
}

.text-day {
  font-weight: 400;
  font-size: 12px;
  color: #94a3b8;
  margin-left: 16px;
  margin-bottom: 0px;
}

.text-reviewed {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  text-transform: none;
}

.text-link {
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.review-text {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 8px;
}

.star-container {
  width: 24px;
  height: 24px;
  border-radius: 2px;
}

.review-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
  padding-top: 16px;
}

.see-more {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #94a3b8;
  cursor: pointer;
}

.rate-box {
  font-weight: 700;
  font-size: 12px;
  color: #0f1734;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
}

.footer-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Recommended/RecommendCard.vue